import { Box, Divider, Typography } from '@material-ui/core'

import { useActivitiesCalendar } from '../../contexts/activities-calendar-context'
import { lengthOfDayInPx, weekLength } from '../../utils/constants'
import { useStyles } from './styles'

export function TodayOverlay() {
  const classes = useStyles()
  const { today } = useActivitiesCalendar()

  if (!today.enabled) return null

  return (
    <div className={classes.container}>
      <Box className={classes.today} left={today.index * lengthOfDayInPx}>
        <Typography component={'span'}>Hoje</Typography>
        <Divider orientation='vertical' />
      </Box>

      <Box
        className={classes.week}
        left={weekLength * today.startWeekIndex * lengthOfDayInPx}
      />
    </div>
  )
}
